<template>
    <!-- StaffMemberSearchItem.vue -->
    <base-search-item :to="staffMemberUrl" v-bind="$props"></base-search-item>
</template>

<script>
    import {STAFF_MEMBER_ICON} from '@/store/static/base-icons'
    import {STAFF_MEMBER} from '@/router/staff-member/route-names'
    // Components
    import BaseSearchItem from './BaseSearchItem'

    export default {
        name: 'StaffMemberSearchItem',
        extends: BaseSearchItem,
        components: {
            BaseSearchItem
        },
        props: {
            /**
             * The list item icon
             */
            icon: {
                type: String,
                default: STAFF_MEMBER_ICON
            }
        },
        computed: {
            staffMemberUrl () {
                const vm = this
                return {
                    name: STAFF_MEMBER,
                    params: {
                        staffMemberId: vm.item.id
                    }
                }
            }
        }
    }
</script>
